import React, { useMemo } from 'react';
import { FiShoppingBag } from 'react-icons/fi';

const FeaturesBreakdown = ({ products, loading }) => {
    const featuresData = useMemo(() => {
        // Extract all features from products
        const allFeatures = products?.flatMap(product => product.features || []) || [];
        
        // Count occurrences of each feature
        const featureCounts = allFeatures.reduce((acc, feature) => {
            acc[feature] = (acc[feature] || 0) + 1;
            return acc;
        }, {});
        
        // Sort by most frequent
        return Object.entries(featureCounts)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 6);
    }, [products]);

    if (loading) {
        return (
            <div className="bg-white rounded-xl shadow-sm p-5">
                <div className="animate-pulse">
                    <div className="h-5 bg-gray-200 rounded w-1/3 mb-6"></div>
                    <div className="space-y-3">
                        {[1, 2, 3, 4, 5, 6].map(i => (
                            <div key={i} className="h-6 bg-gray-100 rounded w-full"></div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-xl shadow-sm p-5 h-full">
            <div className="flex justify-between items-center mb-5">
                <h3 className="text-lg font-semibold text-gray-800">Popular Features</h3>
                <div className="p-2 rounded-lg bg-amber-50">
                    <FiShoppingBag className="text-amber-500" />
                </div>
            </div>
            
            <div className="space-y-3">
                {featuresData.length > 0 ? (
                    featuresData.map(([feature, count], index) => {
                        const percentage = Math.round((count / products.length) * 100);
                        return (
                            <div key={index} className="group">
                                <div className="flex justify-between mb-1">
                                    <span className="text-sm font-medium text-gray-700 truncate max-w-[70%]">
                                        {feature}
                                    </span>
                                    <span className="text-xs font-medium text-gray-500">
                                        {count} plans ({percentage}%)
                                    </span>
                                </div>
                                <div className="w-full bg-gray-100 rounded-full h-2">
                                    <div 
                                        className="bg-gradient-to-r from-amber-400 to-amber-500 h-2 rounded-full transition-all duration-500 ease-out group-hover:from-amber-500 group-hover:to-amber-600"
                                        style={{ width: `${percentage}%` }}
                                    ></div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="py-8 text-center text-gray-500">
                        <p>No feature data available</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FeaturesBreakdown; 